import React from 'react';
import { useLocation, useOutlet } from 'react-router';
import { AnimatePresence } from 'motion/react';

export function AnimatedOutlet() {
  const location = useLocation();
  const element = useOutlet();

  return (
    <AnimatePresence mode="wait">
      {element && React.cloneElement(element, { key: location.pathname })}
    </AnimatePresence>
  );
}
